function DataCheck(data) {
    var i = null
    data.forEach((item, index) => { // 遍历数组
        for (i in item) { // 遍历对象
            if (typeof (i) === 'string') {
                if(item[i] !== null){
                    if (item[i][0] === '[' && item[i][item[i].length - 1] === ']') {
                        item[i] = JSON.parse(item[i])
                    }
                    if (item[i][0] === '{' && item[i][item[i].length - 1] === '}') {
                        item[i] = JSON.parse(item[i])
                    }
                }
            }
        }
    })
    return data
}

export default {
    DataCheck,
}